import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'article-body-text',
  styleUrl: 'article-body-text.css',
  shadow: false,
})
export class ArticleBodyText {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The Body Text
   */
  @Prop() bodyText: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Buttons Data
   */
  @Prop() buttonsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image alt
   */
  @Prop() imageAlt: string;

  /**
   * Image Url
   */
  @Prop() imageUrl: any;

  /**
   * Video
   */
  @Prop() videoUrl: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  /**
   * Element Selection
   */
  @Element() el: HTMLElement;  // This injects a reference to the host element

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }

  componentDidLoad() {
    // Select all elements with an inline style attribute within a specific container
    var elementsWithStyle = this.el.querySelectorAll('.body-text-wrapper [style]');

    // Iterate over each element and remove its style attribute
    elementsWithStyle.forEach(function(element) {
      // Check if the element is an image
      if (element.tagName !== 'IMG') { 
        element.removeAttribute('style');
    }
    });
  }

  render() {
    //console.log('data', this.imageUrl);
    const jsonBodyText = JSON.parse(this.bodyText);
    
    //console.log('jsonBodyText', jsonBodyText);
    return (
      <Host>
        <div
          class={`${this.backgroundColor} article-body-container flex items-center relative  justify-center ${this.textOrientation} ${this.paddingBottom} ${this.paddingTop}`}
          style={{ backgroundImage: `url(${this.backgroundImage})` }}
        >
          <div class={`body-text-wrapper `}>
            {this.bodyText && <div class={`body-text`} innerHTML={jsonBodyText.replace(/â€˜/g, "'").replace(/â€™/g, "'").replace(/â€”/g, '-')}></div>}
          </div>
        </div>
      </Host>
    );
  }
}
